import script from "./CreditsBalance.vue?vue&type=script&setup=true&lang=js"
export * from "./CreditsBalance.vue?vue&type=script&setup=true&lang=js"

import "./CreditsBalance.vue?vue&type=style&index=0&id=63f6cd2a&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63f6cd2a"]])

export default __exports__